module.exports = __webpack_public_path__ + "img/saum_kieferngruen_ral6028.35a158e2.jpg";